import React from "react";
import Label from "../Label";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  required?: boolean;
  value: string;
}

const EmailField: React.FC<Props> = ({
  id,
  label,
  name,
  onChange,
  required,
  value
}) => {
  return (
    <div className="field text-field">
      <label htmlFor="email">
        <Label labelName={label} />
      </label>
      <input
        id={id || name}
        name={name}
        type="email"
        onChange={onChange}
        required={required}
        value={value}
      />
    </div>
  );
};

export default EmailField;
